import { render, staticRenderFns } from "./NFContent.vue?vue&type=template&id=16da62f5"
import script from "./NFContent.vue?vue&type=script&lang=js"
export * from "./NFContent.vue?vue&type=script&lang=js"
import style0 from "./NFContent.vue?vue&type=style&index=0&id=16da62f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports